<div class="row">
  <div class="col-md-11">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
      <div class="row">
        <div class="col-md-7">
          <div class="card-header wh-header2  padding-left-7px padding-top-0px">
            Referral Details
            <!--<button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>-->

          </div>
        </div>
        <div class="col-md-3 padding-right-0px">
          <button type="button"
                  class="btn  actions-btn-prime float-right margin-top-5px" (click)="AddReferralDetails()">
            Add New
          </button>
        </div>
      </div>
    </div>
  </div>


</div>
